import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { version } from '../../../package.json';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  userForm = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required)
  });
  
  loading = false;
  error: string;
  returnUrl: string;
  hidePass: boolean = true;

  public version: string = version;


  constructor(public route: ActivatedRoute, public router: Router, public authService: AuthService) {
  }

  ngOnInit() {
    // reset login status
    //this.authService.logout();

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/home';
  }

  login() {
    this.authService.logout();
    this.loading = true;
    this.error = 'Connecting to HVS Portal';
    this.authService.login(this.userForm.controls['username'].value, this.userForm.controls['password'].value)
      .subscribe(
        data => {
          //this.router.navigate(['/home']);
          this.router.navigate([this.returnUrl]);
          this.loading = false;
        },
        error => { 
          this.error = 'Incorrect username or password.';
          this.loading = false;
        });
  }

  register() {
    this.router.navigate(['/register'])
  }

  handleEnter(e) {
    if (e.keyCode == 13) {
      this.login();
    }
  }

}
